import React from 'react';
import styled from 'styled-components';
import { Typography } from 'antd';
import { TextProps as AntdTextProps } from 'antd/lib/typography/Text';

const { Text: AntdText } = Typography;

export interface TextProps extends Omit<AntdTextProps, 'ellipsis'> {
  block?: boolean;
  textAlign?: 'left' | 'center' | 'right';
  ellipsis?: boolean | number;
  nowrap?: boolean;
  color?: string;
  fontSize?: number;
  dataCy?: string;
}

export const Text: React.FC<TextProps> = ({
  block,
  textAlign = 'left',
  ellipsis,
  nowrap,
  color,
  fontSize,
  dataCy,
  ...props
}) => (
    <StyledText
      $block={textAlign !== 'left' ? true : block}
      $textAlign={textAlign}
      $width={typeof ellipsis === 'number' ? `${ellipsis}px` : 'auto'}
      $nowrap={nowrap}
      ellipsis={Boolean(ellipsis)}
      $color={color}
      $fontSize={fontSize}
      data-cy={dataCy}
      {...props}
    />
  );

const StyledText = styled(AntdText)<{
  $textAlign: TextProps['textAlign'];
  $block: TextProps['block'];
  $nowrap: TextProps['nowrap'];
  $width: string;
  $color: string;
  $fontSize: number;
}>`
  && {
    text-align: ${({ $textAlign }) => $textAlign};
    ${({ $block }) => $block && `display: block`};
    ${({ $nowrap }) => $nowrap && `white-space: nowrap`};
    width: ${({ $width }) => $width};
    color: ${({ $color }) => $color};
    ${({ $fontSize }) => $fontSize && `font-size: ${$fontSize}px`};
  }
`;

export default styled(Text)``;
